module.exports = __webpack_public_path__ + "static/media/system-oto-modulesA-img.9be2cce2.png";